import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import {
  apiURL,
  formatDate,
  formatKW,
} from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const SapServiceDeliveryTimes = () => {
  const { t } = useTranslation()
  const { data, loading, error } = useAxiosPartnerPortal(
    apiURL('delivery_times'),
    {},
    'post'
  )

  return (
    <div className="spa-block-full mt-2">
      <div>
        {loading && <LoadingSpinner />}
        {data && (
          <>
            <table className="table table-condensed table-striped">
              <thead>
                <tr>
                  {t('generic.spa.results.delivery_times.columns').map(
                    (c, index) => (
                      <th key={index}>{c}</th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => (
                  <tr key={index}>
                    <td>
                      KW {formatKW(row.kalenderwoche)}
                      <br />
                      {formatDate(row.datum_von)} - {formatDate(row.datum_bis)}
                    </td>
                    <td>KW {formatKW(row.liefer_kw_ku)}</td>
                    <td>KW {formatKW(row.liefer_kw_so)}</td>
                    <td>KW {formatKW(row.liefer_kw_fu)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p>
              {t('generic.spa.results.delivery_times.disclaimer')}
              &nbsp;
              {formatDate(Date.now())}.
            </p>
          </>
        )}

        {!data && (
          <div className="spa-block-no-results">
            {t('generic.spa.no_results')}
          </div>
        )}
      </div>
    </div>
  )
}

export default SapServiceDeliveryTimes
